import React from "react";
import "./index.scss";
const Crash = () => <div
  className={"crash-boundary-info"}>
  <div>We're sorry for the inconvenience.
  </div>
  <div>Please refresh the page, or if the issue persists, reach out to support for assistance.
  </div>
</div>;

export class CrashBoundary extends React.Component<any, { hasCrash: boolean }> {
  state = {
    hasCrash: false
  }
  unlisten?: () => void;

  static getDerivedStateFromError() {
    return {hasCrash: true};
  }

  componentDidMount() {
    this.unlisten = this.props.history?.listen(() => {
      this.setState({hasCrash: false});
    });
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  render() {
    return (
      this.state.hasCrash? <div style={{height: "100%"}}> <Crash/></div>:
          this.props.children
    );
  }
}
